<script setup lang="ts">
/*
 * @descriptions: 是否显示关注公众号弹窗
 */
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import common from '@/utils/common'
import { hideShowSubscribe } from '@/api/common'

const { VITE_APP_MJ_CLOUD_EDU_ORIGIN } = import.meta.env
let userInfo = common.getCache('user')
let sso_id = ref('')

if (userInfo && JSON.stringify(userInfo) !== '{}') {
  sso_id.value = JSON.parse(userInfo).sso_id
}

// 数据初始化
const dialogVisible = ref(false)
const imgUrl = `${VITE_APP_MJ_CLOUD_EDU_ORIGIN}/api/wechat/getSubscribeQrCodeImg?sso_id=${sso_id.value}`

const onLater = () => {
  hideShowSubscribe({}).then((res) => {
    console.log(res)
    let { code } = res
    if (code === 0) {
      dialogVisible.value = false
    }
  })
}

// 暴露组件的属性和方法
defineExpose({
  dialogVisible
})
</script>

<template>
  <el-dialog
    draggable
    :show-close="false"
    :close-on-click-modal="false"
    v-model="dialogVisible"
    width="360"
    align-center
  >
    <div class="wechat-div">
      <img class="mj-theme-b" :src="imgUrl" />
      <!-- 区分美吉、桑格 -->
      <h2 v-if="common.getWebName() === 'mj'">美吉生物服务号已上线</h2>
      <h2 v-if="common.getWebName() === 'sg'">桑格信息服务号已上线</h2>
      <p>微信关注即可获得最新项目进展</p>
    </div>
    <template #footer>
      <div class="dialog-footer text-center">
        <el-button @click="onLater">
          <span class="blue mj-theme-ft">稍后再说</span>
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped lang="scss">
.wechat-div {
  text-align: center;
  img {
    width: 250px;
    height: 250px;
    border: 11px solid #3d83e9;
    border-radius: 10px;
    box-sizing: initial;
  }
  h2 {
    font-size: 16px;
    font-weight: 700;
    margin: 25px 0 10px;
  }
  p {
    color: #666;
    font-size: 16px;
    line-height: 1.75;
    margin-bottom: 15px;
  }
}
</style>
